/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Sort Icon
 *
 * @file SortIcon.jsx
 * @author Gladson Samuel S
 * @since 0.0.1
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropType from 'prop-types';

const SortIcon = ({ className }) => (
  <SvgIcon className={className} xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.31552 7.45808C7.63661 7.77918 7.63661 8.29978 7.31552 8.62088L4.58137 11.355C4.26027 11.6761 3.73967 11.6761 3.41857 11.355L0.684427 8.62088C0.363329 8.29978 0.363329 7.77918 0.684427 7.45808C1.00552 7.13698 1.52613 7.13698 1.84722 7.45808L3.99997 9.61083L6.15272 7.45808C6.47382 7.13698 6.99442 7.13698 7.31552 7.45808ZM4.58137 0.644754L7.31552 3.3789C7.63661 3.7 7.63661 4.2206 7.31552 4.5417C6.99442 4.8628 6.47382 4.8628 6.15272 4.5417L3.99997 2.38895L1.84722 4.5417C1.52613 4.8628 1.00552 4.8628 0.684427 4.5417C0.363329 4.2206 0.363329 3.7 0.684427 3.3789L3.41857 0.644754C3.73967 0.323656 4.26027 0.323656 4.58137 0.644754Z" fill="currentColor" />
  </SvgIcon>
);

SortIcon.propTypes = {
  className: PropType.string.isRequired
};

export default SortIcon;

